import createEnum from 'scripts/lib/create_enum';

export default createEnum('BROWSER', 'DIRECT_DIAL', 'NONE', 'STATION');
